module.exports = __webpack_public_path__ + "img/mobproject.94f935a7.svg";